export default __webpack_public_path__ + "7e07a59569e02e1f7930fd224684396c.ttf";